import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20Korean%20webtoon%20style%20illustration%2C%20a%20dynamic%20collage%20of%20manga%20characters%20in%20various%20action%20poses%2C%20warm%20coral%20and%20golden%20accents%2C%20dramatic%20light%20rays%2C%20modern%20digital%20art%2C%20abstract%20geometric%20shapes%2C%20vibrant%20energy%2C%20clean%20composition%20with%20dark%20corners%20for%20text%20overlay&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫在线 - 免费韩漫在线阅读平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
            <i className="ri-sparkling-line text-primary-400 text-sm"></i>
            <span className="text-sm text-primary-300">每日更新 · 海量韩漫免费看</span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            韩漫在线 -
            <span className="text-primary-400"> 免费韩漫</span>
            大全
          </h1>
          <p className="text-base md:text-lg text-background-50/70 mb-8 max-w-2xl mx-auto leading-relaxed">
            韩漫在线提供韩漫免费在线观看服务，涵盖免费韩漫大全、韩漫在线免费阅读与韩漫免费看全集漫画资源。无需付费，直接畅读，每日更新热门韩漫。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-full transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
            >
              <i className="ri-book-read-line mr-2"></i>
              开始阅读
            </Link>
            <Link
              to="/category/romance"
              className="w-full sm:w-auto px-8 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-full border border-background-50/30 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
            >
              <i className="ri-heart-line mr-2"></i>
              热门恋爱漫
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">10,000+</div>
              <div className="text-xs text-background-50/50 mt-1">漫画资源</div>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">500万+</div>
              <div className="text-xs text-background-50/50 mt-1">月活跃读者</div>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">每日更新</div>
              <div className="text-xs text-background-50/50 mt-1">持续连载</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}